export default {
  language_selector: {
    label: 'Escolher idioma',
  },
  nav_items: {
    home: 'Início',
    menu: 'Menu',
    locations: 'Localizações',
    store_info: 'Info da Loja',
    rewards: 'Recompensas',
  },
};
